(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function () {
    function initCustomSort() {
        const list = document.querySelector('results-list[data-custom-sort="true"]');
        if (!list) return;

        // Only reorder the plain, unfiltered/unsorted overview (no query
        // string at all). A filtered, sorted, searched or paginated view
        // keeps whatever order Shopify/the filters app already produced.
        if (window.location.search !== '') {
          list.classList.remove('custom-sort-pending');
          return;
        }

        const sectionId = list.getAttribute('section-id');
        // Scope strictly to the product-grid <li> items: product cards also
        // stamp data-product-id on nested elements (quick add, etc.), so an
        // unscoped selector would match several elements per product.
        const items = Array.from(list.querySelectorAll('li[data-product-id]'));
        if (!sectionId || items.length < 2) {
          list.classList.remove('custom-sort-pending');
          return;
        }

        const parent = items[0].parentElement;
        const itemsByProductId = {};
        items.forEach((el) => {
          itemsByProductId[el.getAttribute('data-product-id')] = el;
        });

        const reveal = () => list.classList.remove('custom-sort-pending');
        // Safety net: never hide the grid for more than a moment.
        const revealTimeout = setTimeout(reveal, 1500);

        function fetchOrder(sortBy) {
          const url = `${window.location.pathname}?sort_by=${sortBy}&section_id=${sectionId}`;
          return fetch(url)
            .then((res) => res.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              return Array.from(doc.querySelectorAll('li[data-product-id]')).map((el) =>
                el.getAttribute('data-product-id')
              );
            });
        }

        Promise.all([fetchOrder('created-descending'), fetchOrder('best-selling')])
          .then(([newestOrder, bestSellingOrder]) => {
            if (!newestOrder.length || !bestSellingOrder.length) return;

            const newestId = newestOrder[0];
            const finalOrder = [newestId].concat(
              bestSellingOrder.filter((id) => id !== newestId)
            );
            Object.keys(itemsByProductId).forEach((id) => {
              if (!finalOrder.includes(id)) finalOrder.push(id);
            });

            const fragment = document.createDocumentFragment();
            finalOrder.forEach((id) => {
              const el = itemsByProductId[id];
              if (el) fragment.appendChild(el);
            });
            parent.appendChild(fragment);
          })
          .catch((err) => {
            /* keep default order on failure */
            console.warn('[custom collection sort] falling back to default order:', err);
          })
          .finally(() => {
            clearTimeout(revealTimeout);
            reveal();
          });
      }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCustomSort);
    } else {
      initCustomSort();
    }

    // Custom fix: after a filter, sort, or search change, Shopify's Section
    // Rendering API re-fetches and re-morphs this same <results-list>
    // element in place (no full page reload). The freshly rendered HTML
    // from the server always re-adds the "custom-sort-pending" class on
    // this all-products view (Liquid can't see the query string - see the
    // comment at the top of this file), but initCustomSort() above only
    // ever ran once per full page load. Without this, every filter/sort/
    // search click left "custom-sort-pending" stuck on the grid (hidden via
    // the CSS rule below), so the matching products never reappeared even
    // though the filter count was correct. Re-run the check any time that
    // class comes back, so the early-exit branch above removes it again
    // (filtered/sorted views) or the blend-sort re-runs (back to the plain
    // overview, e.g. after "Alles löschen").
    const observedList = document.querySelector('results-list[data-custom-sort="true"]');
    if (observedList) {
      new MutationObserver(() => {
        if (observedList.classList.contains('custom-sort-pending')) {
          initCustomSort();
        }
      }).observe(observedList, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
